<template>
  <v-data-table
      :headers="headers"
      :items="documents"
      class="elevation-1"
      :items-per-page="itemsPerPage"
      item-key="fileId"
      disable-sort-by
      :loading="innerLoading"
      :locale="systemLocale">
    <template v-slot:progress>
      <v-progress-linear :active="innerLoading" color="loader" indeterminate />
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.documentType="{ item }">
      {{ $t(DOCUMENT_TYPE_ENUM[item.documentType]) }}
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.creationDate="{ item }">
      {{ item.creationDate
        ? $moment(item.creationDate).format('DD.MM.YYYY HH:mm')
        : null }}
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.fileId="{ item }">
      <btn-icon-tip
          icon="get_app"
          :tip="$t('Скачать документ')"
          @click="getBusinessFile(item.fileId)" />
    </template>
  </v-data-table>
</template>

<script>
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import getFileMixin from '@/utils/mixins/scoped/getFileMixin.js'
  import { DOCUMENT_TYPE_ENUM } from '@/constants/enums'

  export default {
    components: {
      BtnIconTip
    },
    mixins: [
      getFileMixin('isLoading')
    ],
    props: {
      loading: {
        type: Boolean,
        default: false
      },
      documents: {
        type: Array,
        required: true,
        default: function () {
          return []
        }
      }
    },
    data () {
      return {
        itemsPerPage: 10,
        isLoading: false,
        DOCUMENT_TYPE_ENUM
      }
    },
    computed: {
      headers () {
        return [
          { text: this.$t('Документ'), align: 'start', sortable: true, value: 'documentType' },
          { text: this.$t('Редакция от'), align: 'start', sortable: true, value: 'creationDate' },
          { text: this.$t('Действия'), align: 'start', sortable: false, value: 'fileId' }
        ]
      },
      innerLoading () {
        return this.isLoading || this.loading
      }
    },
    methods: {

    }
  }
</script>
